import React, { FC, memo, PropsWithChildren } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { AlertStyled, SpanNote } from './styles';
import { FnAlertTypes } from './constants';

type TProps = {
  type?: FnAlertTypes;
};

const FnAlert: FC<PropsWithChildren<TProps>> = ({ type = FnAlertTypes.Info, children }) => (
  <AlertStyled type={type}>
    <FontAwesomeIcon icon={faInfoCircle} />
    <SpanNote>Please note</SpanNote>
    {children}
  </AlertStyled>
);

export default memo(FnAlert);
